import { css } from 'aphrodite';
import { FC, ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { useEventLogging } from '../../../../../../models/Logging';
import { Button } from '../../../../../components-v2/Button';
import { ROUTES } from '../../../../../constants/routes';
import { MailSparkleIcon } from '../../../../svgs/icons/MailSparkleIcon';
import { AgentRow, AgentRowIcon } from '../../AgentRow';
import { styleSheet } from '../../styles';
import { INBOX_ASSISTANT_TELEMETRY_CATEGORY } from './DashboardInboxAssistantRow';

export const DashboardInboxAssistantFirstRunRow: FC<{
	detail: ReactNode;
	isRunning: boolean;
	onRunNow: () => void;
}> = ({ detail, isRunning, onRunNow }) => {
	const { logEvent } = useEventLogging(INBOX_ASSISTANT_TELEMETRY_CATEGORY);
	return (
		<AgentRow
			icon={
				<AgentRowIcon>
					<MailSparkleIcon />
				</AgentRowIcon>
			}
			title='Inbox Assistant'
			detail={detail ?? 'You’re all set up — run your first brief.'}
			action={
				<>
					<Button size='sm' onClick={onRunNow} isLoading={isRunning} disabled={isRunning}>
						Run now
					</Button>
					<NavLink
						className={css(styleSheet.scheduleLink)}
						to={ROUTES.emailExec.settings}
						onClick={() => logEvent('ScheduleLinkClicked')}
					>
						set a schedule
					</NavLink>
				</>
			}
		/>
	);
};
